import { RootState } from '..';
import { getNestedField } from '../utils';

export const getTicket =
  (state: RootState) =>
  <T extends FlattenKeys<TicketState>>(field: T) =>
    getNestedField(state.ticket, field);

const ticketGetters = (state: RootState) => ({
  getTicket: getTicket(state),
});

export default ticketGetters;
